import React from 'react'

export const Footer = () => {
 
  return (
    <footer className='bg-dark text-light py-3'>
      <p className='text-Center'>
        Copyright &copy; MyTodosList.com
        </p>
      </footer>
  )
}
